import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_PLC_STATUS } from "./actionTypes";
import { getPlcStatusSuccess, getPlcStatusError } from "./actions";

// Include call API
import { getSystemAPI } from "../../../api/system";

const systemAPI = getSystemAPI();

function* getPlcStatusFetch(action) {
  try {
    const response = yield call(systemAPI.getPlcStatus, action.payload?.token);
    let plc_status = response.plc_status;
    yield put(getPlcStatusSuccess("Get plc status ok", plc_status));
  } catch (error) {
    yield put(getPlcStatusError(error));
  }
}

export function* watchGetPlcStatus() {
  yield takeEvery(GET_PLC_STATUS, getPlcStatusFetch);
}

function* getPlcStatusSaga() {
  yield all([fork(watchGetPlcStatus)]);
}

export default getPlcStatusSaga;
